module.exports = "/images/f8630511015fb30cf04c7c6f9c2d0476.svg";